import type { SignalDiagnostic } from "../../types";
import type { HeroTone } from "./HeroCard";

/**
 * Fonte ÚNICA do texto de diagnóstico AIN/MB nos cards.
 *
 * Existia só dentro do `GaugeWidget`, então os widgets de gráfico
 * (`RateHeroWidget`, `ChartWidget`) e o KPI ignoravam `value.diagnostic` por
 * completo. O efeito não era cosmético: com falha elétrica o `selectors.ts`
 * anula o valor mas mantém `isAvailable`, e o `RateHeroWidget` lia
 * `rate === null` como "Parada agora" — fio partido apresentado como máquina
 * parada. Com o texto compartilhado, quem tem diagnóstico fala a mesma língua.
 *
 * `null` quando não há diagnóstico (modo sem `s` de diagnóstico, ou `MB` em
 * `s=1`): aí o card volta a falar pelo tom/limite, como antes.
 */
export function describeSignalDiagnostic(
  diagnostic: SignalDiagnostic | undefined,
): { tone: HeroTone; text: string } | null {
  switch (diagnostic) {
    case "fault":
      return { tone: "danger", text: "Falha no sinal analógico" };
    case "under-range":
      return { tone: "warn", text: "Abaixo da faixa do sensor" };
    case "over-range":
      return { tone: "warn", text: "Acima da faixa do sensor" };
    case "modbus-never":
      return { tone: "warn", text: "Aguardando primeira leitura Modbus" };
    case "modbus-timeout":
      return { tone: "danger", text: "Sem resposta do equipamento Modbus" };
    case "modbus-bad-frame":
      return { tone: "danger", text: "Resposta Modbus inválida" };
    case "modbus-exception":
      return { tone: "danger", text: "Equipamento retornou exceção Modbus" };
    default:
      return null;
  }
}
